'use client';

import { goMainOneTimeAuth } from '@/utils/functions';
import { ContactHeaderSideNode as CommonContactHeaderSideNode } from '@monorepo/common';

function ContactHeaderSideNode() {
  const handleNavigate = (path: string) => {
    goMainOneTimeAuth({
      redirectPath: path,
    });
  };

  return <CommonContactHeaderSideNode redirectPath='/account/contact-history' onNavigate={handleNavigate} />;
}

export default ContactHeaderSideNode;
